module.exports = __webpack_public_path__ + "img/9788990090942.14f2fea7.jpg";